export const parseNextPage = (next: string) => {
  try {
    return decodeURIComponent(next);
  } catch {
    return '/';
  }
};
